import { render } from "./LangueSelector.vue?vue&type=template&id=ecfb7c9e"
import script from "./LangueSelector.vue?vue&type=script&lang=js"
export * from "./LangueSelector.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__